import { useStoreActions, useReducerData } from 'store/hooks';
// ACTIONS
import * as addProductActions from 'views/AddProduct/actions';
import * as inspectionActions from 'views/Inspection/redux/actions';
import * as documentManagementActions from 'views/DocumentManagement/redux/actions';

export const useIndexData = () => {
  const serviceProviders = useReducerData('qcInspection', 'serviceProviders.data', []);
  return {
    serviceProviders,
  };
};

export const useActions = () => {
  return useStoreActions({
    ...addProductActions,
    ...inspectionActions,
    ...documentManagementActions,
  });
};
